import React from 'react';

import { TextField, TextFieldProps } from '@mui/material';

import ResizeIcon from './assets/resize.svg';
import useStyles from './styles';

type Props = Omit<TextFieldProps, 'variant' | 'size' | 'color' | 'type'> & {
    type?: TextFieldProps['type'] | 'password-visible';
};

const TextAreaInput: React.ForwardRefRenderFunction<HTMLInputElement, Props> = (
    { className, InputProps, InputLabelProps, ...restProps },
    ref
) => {
    const { classes: internalClasses, cx } = useStyles();

    return (
        <TextField
            ref={ref}
            variant="outlined"
            className={cx(internalClasses.field, className)}
            FormHelperTextProps={{ error: true, className: internalClasses.error }}
            autoComplete=""
            multiline
            rows={5}
            InputProps={{
                ...InputProps,
                autoComplete: 'new-password',
                endAdornment: <ResizeIcon className={internalClasses.icon} />,
                classes: {
                    ...InputProps?.classes,
                    root: cx(internalClasses.inputRoot, InputProps?.classes?.root),
                    notchedOutline: internalClasses.notchedOutline,
                    input: cx(internalClasses.input, InputProps?.classes?.input)
                }
            }}
            InputLabelProps={{
                ...InputLabelProps,
                classes: {
                    ...InputLabelProps?.classes,
                    root: cx(internalClasses.label, InputLabelProps?.classes?.root),
                    focused: cx(internalClasses.labelFocused, InputLabelProps?.classes?.focused),
                    shrink: cx(internalClasses.labelShrink, InputLabelProps?.classes?.shrink)
                }
            }}
            {...restProps}
        />
    );
};

export default React.memo(React.forwardRef(TextAreaInput));
